import React from 'react';
import {Avatar, Box, HStack, VStack} from '@chakra-ui/react';
import {TextG12, TextG14, TextG22} from '../typography';

export interface ProfileIdentityProps {
  name: string;
  handle?: string;
  photoUrl?: string;
  neighborhood?: string;
  city?: string;
  hasActiveMembership?: boolean;
  isCloseNeighbor?: boolean;
  avatarSize?: string;
  avatarFontSize?: string;
  avatarSlot?: React.ReactNode;
}

/**
 * Shared identity row used by NeighborProfile and MyProfile's Preview tab.
 */
const ProfileIdentity = ({
  name,
  handle,
  photoUrl,
  neighborhood,
  city,
  hasActiveMembership,
  isCloseNeighbor,
  avatarSize = '100px',
  avatarFontSize = '30px',
  avatarSlot,
}: ProfileIdentityProps) => {
  return (
    <HStack spacing={4} px={4} pt={6} pb={2} align="flex-start">
      <Box
        flexShrink={0}
        borderRadius="full"
        border={hasActiveMembership ? '3px solid transparent' : '2px solid #8F8F8F'}
        background={
          hasActiveMembership
            ? 'linear-gradient(white, white) padding-box, linear-gradient(90deg, #C9136B 0%, #FF7A00 50%, #7A1FFF 100%) border-box'
            : undefined
        }
        p={0.5}>
        {avatarSlot ?? (
          <Avatar
            name={name}
            src={photoUrl}
            w={avatarSize}
            h={avatarSize}
            fontSize={avatarFontSize}
          />
        )}
      </Box>
      <VStack align="flex-start" spacing={1} pt={1} minW={0}>
        {(hasActiveMembership || isCloseNeighbor) && (
          <HStack spacing={2} flexWrap="wrap">
            {hasActiveMembership && (
              <Box
                bg="linear-gradient(90deg, #C9136B 0%, #FF7A00 50%, #7A1FFF 100%)"
                color="white"
                px={2.5}
                py={0.5}
                borderRadius="30px">
                <TextG12 mt="0" fontWeight="700" whiteSpace="nowrap">
                  Local Insider
                </TextG12>
              </Box>
            )}
            {isCloseNeighbor && (
              <Box border="2px solid #E9E9E9" px={2.5} py={0.5} borderRadius="30px">
                <TextG12 mt="0" fontWeight="700" whiteSpace="nowrap">
                  Close neighbor
                </TextG12>
              </Box>
            )}
          </HStack>
        )}
        <TextG22 mt="0" fontWeight="700">
          {name}
        </TextG22>
        {handle && (
          <TextG14 mt="0" color="#757D84">
            @{handle}
          </TextG14>
        )}
        {neighborhood && (
          <HStack spacing={1}>
            <i
              className="fi fi-rr-marker"
              aria-hidden="true"
              style={{fontSize: '12px', color: '#1A1A1A'}}
            />
            <TextG14 mt="0" color="#1A1A1A">
              {neighborhood}
              {city ? `, ${city}` : ''}
            </TextG14>
          </HStack>
        )}
      </VStack>
    </HStack>
  );
};

export default ProfileIdentity;
